'use strict';

const models_infos = require('./models_infos.jsx');
const models = Object.keys(models_infos).map(model => model.toLowerCase());
module.exports.getAutocompleteInfos = function (object = {}) {
  const self = module.exports;
  let autocomplete_infos = {};
  Object.keys(object).filter(function (field) {
    // ex : _product, _provider, etc
    return field.startsWith('_') && models.includes(field.slice(1));
  }).forEach(function (field) {
    // Capitalize, remove trailing _
    const model = field.slice(1, 2).toUpperCase() + field.slice(2);
    autocomplete_infos[model] = {
      label: self.getLabel({
        model: model,
        data: object[field]
      }),
      model: object[field]
    };
    delete object[field];
  });
  return autocomplete_infos;
};
module.exports.getLabel = function ({
  model,
  data = {}
}) {
  if (model === 'Page') {
    return data.name;
  }
  if (model === 'News') {
    return data.title;
  }
  if (model === 'Etablishment') {
    return data.name;
  }
  if (model === 'Admin') {
    if (!data.firstname && !data.lastname) return data.login;
    return ((data.firstname || '') + ' ' + data.lastname).trim();
  }
  return data.label;
};
